<template>
	<BaseCmsPage v-slot="{page}">
		<Body :class="'page-auth-orders'" />
		<CmsIntroContainer :page="page" mode="auth">
			<template #h1>
				<h1 v-if="page?.title" class="auth-title-orders"><BaseCmsLabel code="my_orders" /></h1>
			</template>
		</CmsIntroContainer>
		<AuthMainLayout>
			<template #authContent>
				<BaseAuthOrders v-slot="{items: orders}">
					<div id="items_widgetlist_webshop_layout" v-if="orders?.length">
						<AuthWebshopOrders :orders="orders" mode="orders" />
					</div>
				</BaseAuthOrders>
			</template>
		</AuthMainLayout>
	</BaseCmsPage>
</template>

<script setup>
</script>

<style lang="less" scoped>
	
</style>

